import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { bind, DropdownMultiSelectFilter, Enums, IMultiSelectOption } from 'Mri.Web.Common';
import * as React from 'react';
import { Input, Label } from 'reactstrap';
import { displayTelemetryCells } from '../Displays/DisplayCells_Telemetry';
import { displayAggregateCells } from '../Displays/DisplayCells_Aggregate';
import { BsLayoutThreeColumns } from '@react-icons/all-files/bs/BsLayoutThreeColumns';

export interface IColumnSelectorProps {
    onChange(value: { option: string | Mri.WebApi.MeasurementId }[] | null | undefined): void;
    onToggle(isOpen: boolean): void;
    onColumnGroupSelectAllChange(group: string, checked: boolean): void;
    onReset?(): void;
    onSelectAllColumns?(): void;
    readonly columns: IMultiSelectOption<string | Mri.WebApi.MeasurementId>[];
    readonly whitelistedColumns?: IMultiSelectOption<string | Mri.WebApi.MeasurementId>[];
    readonly selectAllColumnsChecked: boolean;
    readonly className?: string;
    readonly link?: boolean;
    readonly aggregateView?: boolean;
}

@observer
export class ColumnSelector extends React.Component<IColumnSelectorProps> {
    public render() {
        const {
            onChange,
            onReset,
            onToggle,
            columns,
            className,
            whitelistedColumns,
            link,
            selectAllColumnsChecked,
            onSelectAllColumns,
            onColumnGroupSelectAllChange,
        } = this.props;

        const renderBefore = (
            <div className="d-flex">
                {onSelectAllColumns && (
                    <div className="px-1 btn btn-link">
                        <Label check className="m-1">
                            <Input type="checkbox" checked={selectAllColumnsChecked} onChange={onSelectAllColumns} />{' '}
                            Select All
                        </Label>
                    </div>
                )}

                {onReset && (
                    <button className="ms-auto btn btn-link" onClick={onReset}>
                        Reset
                    </button>
                )}
            </div>
        );

        return (
            <DropdownMultiSelectFilter
                filter={columns}
                onToggle={onToggle}
                onChange={onChange}
                onGroupSelectAllChange={onColumnGroupSelectAllChange}
                options={whitelistedColumns ?? this.columnOptions}
                print={this.print}
                style={{
                    minWidth: 400,
                }}
                className={className}
                size="md"
                link={link}
                title={<BsLayoutThreeColumns />}
                defaultText={`Find Columns...`}
                dynamicTitle={false}
                showActive={false}
                caret
                showClear={false}
                renderBefore={renderBefore}
                hideConflicts
            />
        );
    }

    @computed
    private get columnOptions() {
        return this.props.aggregateView
            ? displayAggregateCells.map(c => {
                return { option: c.id, group: c.group };
            })
            : displayTelemetryCells.map(c => {
                return { option: c.id, group: c.group };
            });
    }

    private print(entity: string | Mri.WebApi.MeasurementId) {
        return typeof entity == 'number' ? Enums.toString(Enums.MeasurementId, entity) : entity;
    }
}
